import { AutogenLayoutRenditionFaxProfiles } from "./autogen/AutogenLayoutRenditionFaxProfiles";
import { ClickEvent, DropdownItem } from "@mcleod/components";

export class RenditionFaxProfiles extends AutogenLayoutRenditionFaxProfiles {

    override onLoad() {
        this.SetDropDowns();
    }

    SetDropDowns()
    {
        const items: DropdownItem[] = [];
        //items.push({ caption: "Yes", value: "Y" });
        //items.push({ caption: "No", value: "N" });
        items.push(new DropdownItem( "Y", "Yes" ));
        items.push(new DropdownItem( "N", "No" ));
        //Send Cover
        this.textbox2.items = items;
        //Combine Fax
        this.textbox3.items = items;
        //Email Confirmation
        this.textbox15.items = items;
    }

}
